import config from '@/config';
const { API_URL } = config;

const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (error) {
    return null;
  }
};

export const isTokenExpired = (token) => {
  const decodedToken = parseJwt(token);
  if (!decodedToken) {
    return true;
  }
  const now = Date.now() / 1000;
  return decodedToken.exp < now;
};

export const refreshToken = async (token) => {
  try {
    const response = await fetch(`${API_URL}/refresh-token`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Error refreshing token');
    }

    const { data } = await response.json();
    return data.token;
  } catch (error) {
    console.error('Error during refreshing token:', error);
    return null;
  }
};
